import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LetterrequestcustomerRelativeService {

  constructor(private http: HttpClient) { }

  Get(Token: String, id: String): Observable<Array<LetterRequestCustomer_List_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/LetterrequestcustomerRelative?token=" + Token
      + "&id=" + id).pipe(
        map(data => {
          return data as Array<LetterRequestCustomer_List_Interface>
        })
      )
  }


  GetCustomer(Token: String, id: number): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/LetterrequestcustomerRelative/GetCustomer?token=" + Token
      + "&id=" + id).pipe(
        map(data => {
          return data as Array<General_Interface>
        })
      )
  }


  Add(Token: String, customer_id: number, letter_id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/LetterrequestcustomerRelative/Add?token=" + Token
      + "&customer_id=" + customer_id
      + "&letter_id=" + letter_id).pipe(
        map(data => {
          return data as any
        })
      )
  }


  Delete(Token: String, id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/LetterrequestcustomerRelative/Delete?token=" + Token + "&id=" + id).pipe(
        map(data => {
          return data as any
        })
      )
  }

}
